<template>
  <div id="list">
    <router-link to="/recruitment">
      <a id="arrow"><h2>&larr;</h2> </a>
    </router-link>
    <h1>{{ jobs.name }} - {{ jobs.code_job }}</h1>
    <div class="card w-75">
      <div class="card-body">
        <h5>Descrição:</h5>
        <p>{{ jobs.description }}</p>
        <div class="row">
          <div class="col-sm-6">
            <h5>Perfil:</h5>
            <p v-html="jobs.profile"></p>
          </div>
          <div class="col-sm-6">
            <h5>Ofertas:</h5>
            <p v-html="jobs.offer"></p>
          </div>
        </div>
      </div>
    </div>

    <input v-model="search" placeholder="Pesquisar..." />
    <select class="form-select" v-model="interest">
      <option value="all">Todos</option>
      <option value="0">Interessa</option>
      <option value="1">Stand-By</option>
      <option value="2">Não Interessa</option>
    </select>
    <button
      class="btn btn-primary float-right"
      @click="sendEmailAllCandidate()"
    >
      Enviar RECUSA para todos
    </button>
    <table class="table">
      <thead>
        <tr>
          <th scope="col">Nome</th>
          <th scope="col">E-mail</th>
          <th scope="col">CV</th>
          <th scope="col">LinkedIn</th>
          <th scope="col">Competências</th>
          <th scope="col">Outras Competências</th>
          <th scope="col">Comentários</th>
          <th scope="col">Interesse</th>
          <th scope="col">Editar</th>
          <th scope="col">Enviar<br />Recusa</th>
          <th scope="col">Remover</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="application in filter" :key="application.id_application">
          <td>{{ application.candidate_name }}</td>
          <td>
            <a :href="`mailto:${application.candidate_email}`">{{
              application.candidate_email
            }}</a>
          </td>
          <td>
            <span v-if="itemsContains(application.curriculum)">
              <a target="blank" id="cv" @click="CV(application.id_application)"
                ><img style="width:20px" src="../assets/pdf.svg" alt=""
              /></a>
            </span>
            <span v-else>
              <a target="blank" id="cv" @click="CV(application.id_application)"
                ><img style="width:20px" src="../assets/doc.svg" alt=""
              /></a>
            </span>
          </td>
          <td>
            <span v-if="application.linkedin != ''"
              ><a target="blank" :href="application.linkedin"
                ><img
                  style="width:15px"
                  src="../assets/linkedin.svg"
                  alt=""/></a
            ></span>
            <span v-else
              ><a target="blank" disabled
                ><img
                  style="width:15px"
                  src="../assets/linkedinOpacity.svg"
                  alt=""/></a
            ></span>
          </td>
          <td>{{ application.skills }}</td>
          <td>{{ application.other_skills }}</td>
          <td class="comments">
            ...
            <span>{{ application.comments }}</span>
          </td>
          <td>
            <span v-if="application.interest == 0">
              <button class="btn btn-light" id="selected">✔️</button>
              <button
                class="btn"
                @click="changeInterest(application.id_application, 1)"
                id="interest"
              >
                ⏳
              </button>
              <button
                class="btn"
                @click="changeInterest(application.id_application, 2)"
                id="interest"
              >
                ❌
              </button>
            </span>
            <span v-if="application.interest == 1">
              <button
                class="btn"
                @click="changeInterest(application.id_application, 0)"
                id="interest"
              >
                ✔️
              </button>
              <button class="btn btn-light" id="selected">⏳</button>
              <button
                class="btn"
                @click="changeInterest(application.id_application, 2)"
                id="interest"
              >
                ❌
              </button>
            </span>
            <span v-if="application.interest == 2">
              <button
                class="btn"
                id="interest"
                @click="changeInterest(application.id_application, 0)"
              >
                ✔️
              </button>
              <button
                class="btn"
                id="interest"
                @click="changeInterest(application.id_application, 1)"
              >
                ⏳
              </button>
              <button class="btn btn-light" id="selected">❌</button>
            </span>
          </td>
          <td>
            <button
              id="edit"
              data-toggle="modal"
              data-target="1"
              @click="openModal(application.id_application)"
            >
              🖊️
            </button>
          </td>
          <td>
            <span
              v-if="application.send_email == 0 && application.interest == 2"
              ><button
                id="send"
                @click="sendEmailCandidate(application.id_application)"
              >
                📨
              </button></span
            >
            <span v-else-if="application.send_email == 1">
              <button id="send" disabled>✔️</button></span
            >
            <span v-else><button id="send" disabled>📨</button></span>
          </td>
          <td>
            <button id="trash" @click="deleteApp(application.id_application)">
              🗑️
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <p>✔️-Enquadra | ⏳-StandBy | ❌-Não Enquadra</p>
    <span v-if="this.total > 1">
      <span v-if="this.currentPage == 1">
        <button @click="prevPage()" disabled>Prev</button></span
      >
      <span v-else>
        <button @click="prevPage()">Prev</button>
      </span>
      {{ currentPage }}/{{ total }}
      <span v-if="this.currentPage == this.total"
        ><button @click="nextPage()" disabled>Next</button></span
      >
      <span v-else> <button @click="nextPage()">Next</button></span>
    </span>
    <dialog id="editCandidate">
      <form method="dialog">
        <h1>Editar Candidato</h1>
        <span v-for="info in candidate" :key="info.id">
          <div class="form-group">
            <label for="name">Nome:</label>
            <input
              type="text"
              class="form-control"
              id="name"
              aria-describedby="emailHelp"
              :placeholder="info.candidate_name"
              readonly
            />
          </div>
          <label for="email">Email:</label>
          <div class="form-group">
            <input
              type="email"
              class="form-control"
              id="email"
              :placeholder="info.candidate_email"
              readonly
            />
          </div>
          <div class="form-group">
            <label for="tlf">Telemóvel:</label>
            <input
              type="number"
              class="form-control"
              id="tlf"
              :placeholder="info.cellphone"
              readonly
            />
          </div>
          <div class="form-group">
            <label>Competências:</label><br />
            <span v-for="sel in selected1" :key="sel.value"
              ><b>{{ sel.text }} | </b>
            </span>
            <multiselect
              v-model="selected"
              deselect-label="Can't remove this value"
              track-by="text"
              label="text"
              placeholder="Select one"
              :options="options"
              :multiple="true"
            >
            </multiselect>
          </div>
          <div class="form-group">
            <span v-if="info.other_skills == ''">
              <input
                type="text"
                class="form-control"
                id="skills"
                placeholder="Outras competências"
                readonly
              />
            </span>
            <span v-else
              ><input
                type="text"
                class="form-control"
                id="skills"
                :placeholder="info.other_skills"
                readonly
            /></span>
          </div>

          <div class="form-group">
            <label for="message">Mensagem:</label>
            <textarea
              class="form-control"
              id="message"
              rows="3"
              :placeholder="info.about"
              readonly
            ></textarea>
          </div>
          <div class="form-group">
            <label for="comment">Comentários:</label>
            <textarea
              class="form-control"
              id="comment"
              rows="3"
              v-model="comment"
            >
            </textarea>
          </div>
          <button
            style="border:none; background-color: #555555; color:white"
            type="submit"
            @click="comments(info.id_application)"
          >
            Gravar
          </button>
          <button
            style="border:none; background-color: white"
            @click="closeModal()"
          >
            Fechar
          </button>
        </span>
      </form>
    </dialog>
  </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import { mapGetters } from "vuex";
/* import Select from "@/components/Select.vue"; */
export default {
  components: {
    Multiselect,
    /* Select, */
  },
  data: function() {
    return {
      applications: [],
      candidate: [],
      skills: [],
      skills1: [],
      search: "",
      interest: "all",
      selected: [],
      options: [],
      selected1: [],
      comment: "",
      currentPage: 1,
      pageSize: 10,
      total: "",
      jobs: [],
    };
  },
  methods: {
    async getAllApplications() {
      this.applications = [];
      try {
        await this.$store.dispatch("fetchApplications");
        for (let i = 0; i < this.getApplications.data.length; i++) {
          if (this.$route.params.id == this.getApplications.data[i].id_jobs) {
            this.applications.push(this.getApplications.data[i]);
          }
        }
        this.skills = this.skills1;
        let array = [];
        for (let i = 0; i < this.applications.length; i++) {
          for (let j = 0; j < this.skills.length; j++) {
            if (
              this.applications[i].id_application ==
              this.skills[j].application_id
            ) {
              array.push(this.skills[j].name);
            }

            this.applications[i].skills = array;
          }
          array = [];
        }
      } catch (err) {
        this.$swal({
          title: err.data.status,
          icon: "error",
          confirmButtonText: "Ok!",
        });
      }
    },
    async getSkill() {
      await this.$store.dispatch("fetchApplicationsSkills");
      try {
        this.skills1 = this.getAppSkills.data;
        this.getAllApplications();
      } catch (err) {
        this.$swal({
          title: err.data.status,
          icon: "error",
          confirmButtonText: "Ok!",
        });
      }
    },
    async CV(id) {
      try {
        await this.$store.dispatch("getCurriculum", {
          id: id,
        });
      } catch (err) {
        this.$swal({
          title: err.data.status,
          icon: "error",
          confirmButtonText: "Ok!",
        });
      }
    },
    async comments(id) {
      this.$swal({
        title: "Tem a certeza que pretende guardar os dados?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, Guardar",
      }).then((result) => {
        if (result.isConfirmed) {
          try {
            this.$store.dispatch("putComment", {
              id: id,
              comments: this.comment,
            });
            this.addSkill(id);
            this.$swal({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 1500,
              icon: "success",
              title: "Dados atualizados",
            });
          } catch (err) {
            this.$swal({
              title: err.data.status,
              icon: "error",
              confirmButtonText: "Ok!",
            });
          }
        } else {
          this.openModal(id);
        }
        this.getSkill();
        this.getAllJobs();
      });
    },
    async allSkills() {
      try {
        await this.$store.dispatch("fetchSkills");
        for (let i = 0; i < this.getSkills.data.length; i++) {
          this.options.push({
            value: this.getSkills.data[i].id_skills,
            text: this.getSkills.data[i].name,
          });
        }
      } catch (err) {
        this.$swal({
          title: err.data.status,
          icon: "error",
          confirmButtonText: "Ok!",
        });
      }
    },
    async addSkill(id) {
      let id_skills = [];
      for (let i = 0; i < this.selected.length; i++) {
        id_skills.push(this.selected[i].value);
      }
      try {
        await this.$store.dispatch("addSkillToCandidate", {
          id: id,
          skills: id_skills,
        });
      } catch (err) {
        this.$swal({
          title: err,
          icon: "error",
          confirmButtonText: "Ok!",
        });
      }
    },
    async deleteApp(id) {
      this.candidate = this.applications.filter(
        (application) => application.id_application == id
      );
      this.$swal({
        title: `Tem a certeza que pretende eliminar os dados do(a) ${this.candidate[0].candidate_name}?`,
        text: `Ao eliminar este candidato perderá todos os dados do mesmo!`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, Eliminar",
      }).then((result) => {
        if (result.isConfirmed) {
          try {
            this.$store.dispatch("deleteApplication", {
              id: id,
            });
            this.$swal({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 1500,
              icon: "success",
              title: "Candidato eliminado",
            });
          } catch (err) {
            this.$swal({
              title: err.data.status,
              icon: "error",
              confirmButtonText: "Ok!",
            });
          }
          this.getSkill();
          this.getAllJobs();
        }
      });
    },
    async sendEmailCandidate(id) {
      try {
        this.$store.dispatch("fetchSendEmailCandidate", {
          id: id,
        });
        this.$swal({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 1500,
          icon: "success",
          title: "Email enviado para todos os Candidatos!",
        });
      } catch (err) {
        this.$swal({
          title: err.data.status,
          icon: "error",
          confirmButtonText: "Ok!",
        });
      }
      this.getSkill();
      this.getAllJobs();
    },
    async sendEmailAllCandidate() {
      try {
        this.$store.dispatch("fetchSendEmailAllCandidates", {
          id: this.$route.params.id,
        });
        this.$swal({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 1500,
          icon: "success",
          title: "Email enviado",
        });
      } catch (err) {
        this.$swal({
          title: err.data.status,
          icon: "error",
          confirmButtonText: "Ok!",
        });
      }
      this.getSkill();
      this.getAllJobs();
    },
    async changeInterest(id, type) {
      try {
        this.$store.dispatch("putInterest", {
          id: id,
          interest: type,
        });
        this.$swal({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 1500,
          icon: "success",
          title: "Interesse alterado",
        });
      } catch (err) {
        this.$swal({
          title: err.data.status,
          icon: "error",
          confirmButtonText: "Ok!",
        });
      }
      this.getSkill();
      this.getAllJobs();
    },
    async getAllJobs() {
      try {
        await this.$store.dispatch("fetchJobs");
        for (let i = 0; i < this.getJobs.data.length; i++) {
          if (this.getJobs.data[i].jobs_id == this.$route.params.id) {
            this.jobs = this.getJobs.data[i];
          }
        }
      } catch (err) {
        this.$swal({
          title: err,
          icon: "error",
          confirmButtonText: "Ok!",
        });
      }
    },
    async nextPage() {
      if (this.currentPage * this.pageSize < this.filterUsers.length)
        this.currentPage++;
    },
    async prevPage() {
      if (this.currentPage > 1) this.currentPage--;
    },
    itemsContains(file) {
      return file.includes(".pdf");
    },
    closeModal() {
      document.getElementById("editCandidate").close();
    },
    openModal(id) {
      this.candidate = [];
      this.selected1 = [];
      this.selected = [];
      document.getElementById("editCandidate").showModal();
      this.candidate = this.applications.filter(
        (application) => application.id_application == id
      );

      this.comment = this.candidate[0].comments;
      for (let i = 0; i < this.candidate[0].skills.length; i++) {
        for (let j = 0; j < this.options.length; j++) {
          if (this.candidate[0].skills[i] == this.options[j].text) {
            this.selected1.push({
              value: this.options[j].value,
              text: this.candidate[0].skills[i],
            });
          }
        }
      }
    },
  },
  created() {
    this.getSkill();
    this.getAllJobs();
    this.allSkills();
  },
  computed: {
    ...mapGetters(["getApplications"]),
    ...mapGetters(["getAppSkills"]),
    ...mapGetters(["getCurriculum"]),
    ...mapGetters(["getSkills"]),
    ...mapGetters(["getJobs"]),
    filterUsers() {
      return this.applications.filter((application) => {
        let filterResult = true;
        let filterInterest = true;
        if (this.search == "" && this.interest == "all") {
          return filterResult && filterInterest;
        }
        if (this.search !== "") {
          this.currentPage = 1;
          if (
            application.candidate_name
              .toLowerCase()
              .includes(this.search.toLowerCase())
          ) {
            //name
            filterResult = application.candidate_name
              .toLowerCase()
              .includes(this.search.toLowerCase());
            return filterResult;
          }
          //email
          if (
            application.candidate_email
              .toLowerCase()
              .includes(this.search.toLowerCase())
          ) {
            filterResult = application.candidate_email
              .toLowerCase()
              .includes(this.search.toLowerCase());
            return filterResult;
          }
          for (let i = 0; i < application.skills.length; i++) {
            if (
              application.skills[i]
                .toLowerCase()
                .includes(this.search.toLowerCase())
            ) {
              filterResult = application.skills[i]
                .toLowerCase()
                .includes(this.search.toLowerCase());
              return filterResult;
            }
          }
        }
        if (this.interest !== "all") {
          filterInterest = application.interest == this.interest;
          this.currentPage = 1;
          return filterInterest;
        }
      });
    },
    filter() {
      return this.filterUsers
        .slice()
        .reverse()
        .filter((row, index) => {
          this.total = Math.ceil((index + 1) / this.pageSize);
          let start = (this.currentPage - 1) * this.pageSize;
          let end = this.currentPage * this.pageSize;
          if (index >= start && index < end) return true;
        });
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
#list {
  padding: 50px 50px 0px 250px;
}
h1 {
  margin-bottom: 50px;
}
input {
  margin-bottom: 20px;
  margin-right: 10px;
  border-radius: 5px;
  border: 1px solid silver;
}
dialog {
  width: 600px;
  border: 1px solid grey;
  border-radius: 5px;
}
.comments {
  position: relative;
}
.comments span {
  position: absolute;
  top: 0;
  transform: translateY(10%);
  display: none;
  background: white;
  z-index: 20;
  min-width: 150%;
  padding: 1rem;
  border: 1px solid silver;
  border-radius: 5px;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.08), 0 0 6px rgba(0, 0, 0, 0.05);
}
.comments:hover span {
  display: inline;
}
span select {
  border: none;
  text-align: center;
}
option {
  text-align: center;
}
#edit {
  background: none;
  border: none;
}
select {
  margin-left: 10px;
  border-radius: 5px;
  height: 27px;
  border: 1px solid silver;
}
form {
  text-align: left;
}
tbody {
  font-size: 11px;
}
thead {
  font-size: 12px;
}
a h2 {
  text-align: left;
}
#trash,
#send {
  background: none;
  border: none;
}
#selected {
  border-color: green;
  font-size: 13px;
}
#interest {
  font-size: 13px;
}
label {
  font-size: 18px;
}
.card-body {
  text-align: left;
}
.card {
  margin: 0 auto;
  float: none;
  margin-bottom: 10px;
}
#arrow {
  text-decoration: none;
  color: black;
}
#arrow:hover {
  text-decoration: none;
}
td {
  vertical-align: middle;
}
</style>
